import { ErrorProps } from "../../interfaces";
import { styled, Typography } from "@mui/material";

const Container = styled("div")(({ theme }) => ({
  alignItems: "center",
  display: "flex",
  height: "100vh",
  justifyContent: "center",
}));

export default function Error({ text }: ErrorProps) {
  return (
    <Container>
      <Typography color="error" variant="body1">
        {text}
      </Typography>
    </Container>
  );
}
